import { colors } from '@mui/material';
import { jbColors } from 'theme/jbColors';

const white = '#FFFFFF';
const black = '#000000';

export const palette = {
  black,
  white,
  primary: {
    contrastText: white,
    dark: '#232156',
    main: '#001388',
    light: colors.indigo[100],
  },
  secondary: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue['A400'],
    light: colors.blue['A400'],
    lighter: colors.blue['A100'],
  },
  success: {
    contrastText: white,
    dark: colors.green[900],
    main: colors.green[600],
    light: colors.green[400],
    highlight: '#7BAFA3',
  },
  info: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue[600],
    light: colors.blue[400],
  },
  warning: {
    contrastText: white,
    dark: colors.orange[900],
    main: colors.orange[600],
    light: colors.orange[400],
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400],
  },
  text: {
    primary: '#001489',
    secondary: colors.blueGrey[600],
    link: colors.blue[600],
  },
  background: {
    default: jbColors.support.greenSmoke[10],
    paper: white,
  },
  icon: colors.blueGrey[600],
  divider: colors.grey[200],
  grey: {
    contrastText: white,
    dark: '#8d9697',
    darker: '#384142',
    main: '#f0f0f1',
    light: '#f5f5f5',
    brownGrey: '#eeede4',
  },
  brown: {
    darkBrown: '#c0ba97',
    darkerBrown: '#cc8a00',
  },
  oceanblue: {
    main: '#339e91',
  },
};
